import { render, staticRenderFns } from "./CommentTextareaHandler.vue?vue&type=template&id=7b9cd2be"
import script from "./CommentTextareaHandler.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentTextareaHandler.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports